/**
 * The brand-kit sprite symbol ids, on their own so a client component (the
 * per-card Save/Compare controls) can reference a symbol without pulling the
 * sprite markup into its bundle. components/brand-kit/icon-sprite.tsx mounts
 * the symbols (app/layout.tsx renders it on every page) and re-exports these.
 */
export const STAR_SYMBOL_ID = "fk-icon-star"
export const ARROW_UP_RIGHT_SYMBOL_ID = "fk-icon-arrow-up-right"
export const CHEVRON_DOWN_SYMBOL_ID = "fk-icon-chevron-down"
export const ARROW_RIGHT_SYMBOL_ID = "fk-icon-arrow-right"
export const CHEVRON_RIGHT_SYMBOL_ID = "fk-icon-chevron-right"
export const CHEVRON_LEFT_SYMBOL_ID = "fk-icon-chevron-left"
export const COPY_SYMBOL_ID = "fk-icon-copy"
export const CALENDAR_SYMBOL_ID = "fk-icon-calendar"
export const MAIL_SYMBOL_ID = "fk-icon-mail"
export const EXTERNAL_LINK_SYMBOL_ID = "fk-icon-external-link"
export const GLOBE_SYMBOL_ID = "fk-icon-globe"
export const SHOPPING_BAG_SYMBOL_ID = "fk-icon-shopping-bag"
export const LINK_2_SYMBOL_ID = "fk-icon-link-2"
export const HEART_SYMBOL_ID = "fk-icon-heart"
export const HEART_FILLED_SYMBOL_ID = "fk-icon-heart-filled"
export const CHECK_SYMBOL_ID = "fk-icon-check"

/** Every symbol the sprite defines — tests/icon-sprite-repeats.test.ts pins each one to exactly one <symbol>. */
export const SPRITE_SYMBOL_IDS = [
  STAR_SYMBOL_ID,
  ARROW_UP_RIGHT_SYMBOL_ID,
  CHEVRON_DOWN_SYMBOL_ID,
  ARROW_RIGHT_SYMBOL_ID,
  CHEVRON_RIGHT_SYMBOL_ID,
  CHEVRON_LEFT_SYMBOL_ID,
  COPY_SYMBOL_ID,
  CALENDAR_SYMBOL_ID,
  MAIL_SYMBOL_ID,
  EXTERNAL_LINK_SYMBOL_ID,
  GLOBE_SYMBOL_ID,
  SHOPPING_BAG_SYMBOL_ID,
  LINK_2_SYMBOL_ID,
  HEART_SYMBOL_ID,
  HEART_FILLED_SYMBOL_ID,
  CHECK_SYMBOL_ID,
] as const
